import React, { createContext, useContext, useState } from 'react';

const UsersPermissionsContext = createContext();

export function useUsersPermissions() {
  const context = useContext(UsersPermissionsContext);
  if (!context) {
    throw new Error('useUsersPermissions must be used within a UsersPermissionsProvider');
  }
  return context;
}

export function UsersPermissionsProvider({ children }) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [currentProject, setCurrentProject] = useState(null);

  const openUsersPermissionsDialog = (project) => {
    setCurrentProject(project);
    setIsDialogOpen(true);
  };

  const closeUsersPermissionsDialog = () => {
    setIsDialogOpen(false);
    setCurrentProject(null);
  };

  const value = {
    isDialogOpen,
    currentProject,
    openUsersPermissionsDialog,
    closeUsersPermissionsDialog,
  };

  return (
    <UsersPermissionsContext.Provider value={value}>
      {children}
    </UsersPermissionsContext.Provider>
  );
} 